import { useTrackers } from '@ps/web-shared-analytics';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTCLI_Share_viaX } from './SocialShareButtons.messages.json';
import styles from './SocialShareButtons.scss';
import EmailShareButton from './buttons/EmailShareButton';
import FacebookShareButton from './buttons/FacebookShareButton';
import TwitterShareButton from './buttons/TwitterShareButton';

interface Props {
  iconsBorderColor?: string;
  socialIconsColor?: string;
  url: string;
}

const SocialShareButtons: React.FC<Props> = ({ url, socialIconsColor, iconsBorderColor }) => {
  const { linkClicked } = useTrackers();
  const iconStyle = {
    backgroundColor: socialIconsColor,
    border: iconsBorderColor ? `1px solid ${iconsBorderColor}` : 0
  };

  const onClick: React.MouseEventHandler = (event) => {
    const a = (event.target as HTMLElement).closest('a');
    const trackId = a?.getAttribute('data-track-id');

    if (a) {
      const href = a.getAttribute('href');
      linkClicked({
        destinationUrl: href || '',
        linkText: trackId
      });
    }
  };

  return (
    <div className={styles.socialShareButtons}>
      <div className={styles.shareText}>
        <Translation {...TXTCLI_Share_viaX} />
      </div>
      <FacebookShareButton href={url} onClick={onClick} iconStyle={iconStyle} />
      <TwitterShareButton url={url} onClick={onClick} iconStyle={iconStyle} />
      <EmailShareButton body={url} onClick={onClick} iconStyle={iconStyle} />
    </div>
  );
};
export default SocialShareButtons;
